import { articleGraphQL } from '@/query/article/render-article'

const createQuery = () => `
  ... on CompanyFeaturedArticlesWidget {
    id
    featuredArticles {
      ${articleGraphQL}
    }
  }
`

export default createQuery
